import { PlateType } from './../constants';
import { CustomPiece } from './CustomPiece';

export abstract class ComponentKewlox {
  readonly id: number;
  readonly name: string;
  readonly reference: string;
  private _price: number;
  readonly weight: number;
  readonly forSales: boolean;
  readonly visible: boolean;
  readonly height: number;

  abstract compareTo(otherComponent: ComponentKewlox): number;
  abstract getKey(): string;
  abstract get typeComponent(): string;
  // abstract computePrice(
  //   component: CustomPiece<ComponentKewlox>,
  // ): number | undefined;

  constructor(
    id: number,
    name: string,
    reference: string,
    price: number,
    weigth: number,
    forSales: boolean,
    visible: boolean,
    height: number,
  ) {
    this.id = id;
    this.name = name;
    this.reference = reference;
    this._price = price;
    this.weight = weigth;
    this.forSales = forSales;
    this.visible = visible;
    this.height = height;
  }

  get description() {
    return this.getKey();
  }

  get price() {
    return this._price;
  }

  set price(amount: number) {
    this._price = amount;
  }

  computeWeight(component: CustomPiece<ComponentKewlox>): number | undefined {
    return undefined;
  }

  computePrice(component: CustomPiece<ComponentKewlox>): number | undefined {
    return undefined;
  }

  static computeRealWidth(
    width: number,
    glass = false,
    largeDoor = false,
  ): number {
    return width;
  }

  static computeRealHeight(
    height: number,
    plateType?: PlateType | undefined,
    glass = false,
  ): number {
    return height;
  }

  static computeRealDepth(
    depth: number,
    isNatural = false,
    plateType?: PlateType | undefined,
    glass = false,
  ): number {
    return depth;
  }

  includeInto(otherComponent: ComponentKewlox): boolean {
    return true;
  }
}
